export default __webpack_public_path__ + "static/logo-8de0cdb24a973c16c63e8e570c529557.png";